// Composite — AttributeGroupRow constants
// Class hooks kept from the pre-composite markup; Selenium acceptance tests target them.
export const ATTRIBUTE_GROUP_ROW_LEGACY_CLASS = {
    ROW: 'two-section-grid',
    LABEL: 'title-section',
    CONTENT: 'content-section',
    INNER: 'inner-data',
    CHIPS: 'selected-skills',
    ADD_BUTTON: 'add-attribute-btn',
};
